import useSWR from "swr";
import axios from "axios";

function useDesignAndEngineeringClientChart({ startDate, endDate }) {
  return useSWR([
    `${process.env.REACT_APP_API_URL}/design-and-engineering-charts/by-client`, startDate, endDate], async ([url, startDate, endDate]) => {
      const params = new URLSearchParams();

      if (startDate) params.append('startDate', startDate);
      if (endDate) params.append('endDate', endDate);

      const { data: chartData } = await axios.get(`${url}?${params.toString()}`);

      return { chartData };
    });
}

export default useDesignAndEngineeringClientChart;
